import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { Operation } from './operation';
import { OperationState } from './operation-state';

@Injectable()
export class OperationsService<T extends Operation> {
  operationState$: Observable<OperationState> = of(OperationState.Idle);
  isOperating$: Observable<boolean> = of(false);

  protected _operations$ = new BehaviorSubject<T[]>([]);

  constructor() {}

  initialize() {
    const operationsDebounced$ = this._operations$.pipe(debounceTime(10));

    this.operationState$ = operationsDebounced$.pipe(
      map(operations => {
        if (operations.length === 0) {
          return OperationState.Idle;
        }
        if (operations.some(o => o.hasError)) {
          return OperationState.Error;
        }
        if (operations.some(o => !o.isComplete)) {
          return OperationState.Processing;
        }
        return OperationState.Complete;
      }),
      distinctUntilChanged(),
      shareReplay()
    );

    this.isOperating$ = operationsDebounced$.pipe(
      map(operations => operations.some(o => !o.isComplete)),
      distinctUntilChanged(),
      shareReplay()
    );
  }
}
